import { Component, OnInit, ElementRef, HostListener } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { DeviceDetectorService } from 'ngx-device-detector';
import { App as CapacitorApp } from '@capacitor/app';
import { AppService } from 'src/app/app.service';
import { LocalStorageService } from 'src/app/Services/auth-service/local-storage.service';
import { ENDPOINTS, ORG_DETAILS } from 'src/app/app.config';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { FormGroup, FormControl } from '@angular/forms';
import { CartService } from 'src/app/Lazy-loaded-Modules/Cart-Module/cart-page.service';
import { HeaderService } from './header.service';
import { LoginService } from 'src/app/Lazy-loaded-Modules/Account-Modules/login/login.service';
import { ProductDetailsService } from 'src/app/Lazy-loaded-Modules/Product-Modules/Product-details/product-details.service';
import { AppStateService } from 'src/app/Services/app-state.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {
  title = 'inq-sam';
  currentUrl: any = "home";
  private routeSub: Subscription;
  navURL: any = '/'
  c: any;
  profileDetails: any;
  disableButton: boolean = false;
  message: any;
  runApp: any = true;
  searchForm: UntypedFormGroup;
  appDetails: any;
  subTotal = 0;
  preList = [];
  searchResult = [];
  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };
  userLoggedIn: boolean = false;
  private clickListener!: () => void;

  socialMediaData: any = [];
  taxratedId = {
    rateId: 0,
    productTaxId: 0,
    handlingTaxId: 0,
    shippingTaxId: 0
  }

  ordertaxdetails = {
    rateId: 0,
    productTaxId: 0,
    handlingTaxId: 0,
    shippingTaxId: 0,
    productTaxClass: "",
    handlingTaxClass: "",
    shippingTaxClass: ""
  }

  shippingCarriers = {
    shipping_carrier_id: 0,
    shipping_carrier_name: "",
    api_integration_id: 0,
    api_integration_name: ""
  }

  pickdropcall: boolean = false;
  isDropdownOpen: boolean = false;
  cartProducts: any[] = [];
  requestBody = {};
  storedValue: any;
  dropdownVisible: boolean = false;



  @HostListener('window:scroll', ['$event']) // for window scroll events
  scrollFunction() {
    var mybutton = document.getElementById("myBtn");
    if (document.body.scrollTop > 1200 || document.documentElement.scrollTop > 1200) {
      mybutton.style.display = "block";
    } else {
      this.preList = [];
    }

  }


  constructor(

    private router: Router,
    public appService: AppService,
    private localService: LocalStorageService,
    private formBuilder: UntypedFormBuilder,
    private cartService: CartService,
    private headerService: HeaderService,
    private loginService: LoginService,
    private productDetailsService: ProductDetailsService,
    private appStateService: AppStateService

  ) {

  }
  isSearchMenuOpen: boolean = false;

  toggleSearchMenu() {
    this.isSearchMenuOpen = !this.isSearchMenuOpen;
  }
  closeDropdown(): void {
    this.isDropdownOpen = false;
  }
  toggleNavMenu() {
    const navMenu = document.getElementById('nav-menu');
    if (navMenu) {
      navMenu.classList.toggle('active');
    }
  }
  // @HostListener('window:beforeunload', ['$event'])
  // beforeUnloadHander($event: any) {
  // //  this.checkoutLocalstorageService.clearMasterdata();
  // }

  ngOnInit() {
    this.searchForm = new UntypedFormGroup({
      search_term: this.formBuilder.control("", [

      ]),
    });

    this.storedValue = this.appStateService.getValue();
    console.log("appStateService", this.storedValue)
    this.userLoggedIn = this.storedValue!=null? this.storedValue.userLoggedIn:false;

    this.cartService.cartProducts$.subscribe((products) => {
      this.cartProducts = products;
      // Update the cartProducts array whenever it changes
      console.log(this.cartProducts, " this.cartProducts")
    });

    // console.log(this.userLoggedIn, " this.userLoggedIn")

    // this.appService.totalCartItems = this.cartService.totalCartItems();
    // console.log("console", this.cartService.totalCartItems(), this.appService.totalCartItems);
    this.headerService.currentData.subscribe(
      currentData => {
        let curData: any = currentData;
        console.log("curData.name" + curData.name)
        if (curData.name === "subTotal") {
          let tempArray = this.appService.cartProducts.results;
          tempArray.forEach((item) => {
            // this.subTotal = this.subTotal + (item.cost * item.quantity)
            this.subTotal = (item.cost * item.quantity)
          })
        }
      })

    this.headerService.currentData.subscribe(
      currentData => {
        if (currentData === 'clearSearchTerm') {
          // this.closePrelist();
        }
      })
  }


  logOut() {

    this.storedValue.userLoggedIn = false;
    this.storedValue.userName = "";
    console.log(this.storedValue.userName, "login user")
    this.appService.loggedin_user = false;
    this.userLoggedIn = this.appService.loggedin_user;

    // this.cartService.clearCart();
    //this.loggedIn = false;
    this.router.navigate(["/"]);

  }
  login() {
    this.router.navigate([`/login`], { skipLocationChange: false });
  }
  toggleUserDropdown() {
    this.dropdownVisible = !this.dropdownVisible;
  }
  // toggleDropdown(): void {

  //   this.isDropdownOpen = !this.isDropdownOpen;
  //   console.log(" this.isDropdownOpen", this.isDropdownOpen)
  // }
  onSearchChange() {
    let searchData = this.searchForm.controls.search_term.value;
    console.log(searchData, 'searchData', this.searchForm);

    {
      let reqData = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": null,
        "extras": {
          "find": {
            "search": searchData
          }
        }
      }
      this.appService.postApiCall(reqData, ENDPOINTS.GET_PRELIST).subscribe(
        resp => {

          if (resp.result) {
            if (resp.result.data.length != 0) {
              this.preList = resp.result.data;

            }
            else {
              this.preList = [];
              this.preList.push({ "name": resp.message })

            }


          }
          else {
            console.log("222")
            this.preList = [];
            console.log(this.preList, ' this.preList', resp.message)
            this.preList.push({ "name": resp.message })
          }
        },

        err => {
          if (err.error.error.message) {
            console.log(err.error.error.message)
          }
          else {
            console.log('Something bad happened; Please try again!')
          }
        })
    }
    // else {
    //   this.preList = [];
    // }
  }
  clearResults(): void {
    this.preList = [];
  }
  handleOutsideClick(event: MouseEvent): void {
    const searchInput = document.getElementById('search-input');
    const searchList = document.getElementById('search-list');

    if (searchInput && searchList && !searchInput.contains(event.target as Node) && !searchList.contains(event.target as Node)) {
      this.preList = [];
      //  searchList.style.display = 'none';
    }
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const dropdownElement = document.getElementById('dropdownMenuButton');
    if (dropdownElement && !dropdownElement.contains(event.target as Node)) {
      this.dropdownVisible = false;
    }
  }
  ngAfterViewInit(): void {
    this.clickListener = this.handleOutsideClick.bind(this);
    document.addEventListener('click', this.clickListener);
  }
  ngOnDestroy(): void {
    document.removeEventListener('click', this.clickListener);
  }
  async navigationBasedOnSearch(data) {
    if(this.userLoggedIn==true){
      this.requestBody = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": Number(this.storedValue.userId),
        "extras": {
          "find": {
            "search": data.name,
            "lat": 80.63254,
            "long": 56.23541,
            "type": data.general
          }
        },
        "isglobalfilter": false,
        "pagination": true,
        "paginationDetails":
          { "limit": 1, "pagesize": 100 },
        "sorting": true,
        "sortingDetails":
        {
          "sortfield": "name",
          "sortorder": -1
        }
      }
      this.appService.postApiCall(this.requestBody, ENDPOINTS.GET_SEARCHPAGE_RESULT).subscribe(
        resp => {
  
          if (resp.result) {
            if (resp.result.data.length != 0) {
              this.searchResult = resp.result.data[0];
              console.log(resp.result.data[0], this.searchResult);
  
              if (data.general == "SKU" || data.general == "Product Name") {
                console.log("111")
                 this.router.navigate([`/productListing/outletId/${this.searchResult['id']}`]);
                // this.router.navigate([`/product-details/${this.searchResult}/productId/${this.searchResult['id']/outletID/41}`]);
              }
              else if (data.general == "Category") {
                console.log("222")
                // this.router.navigate([`productListing/category/${this.searchResult['category']}/outletId/${this.searchResult['id']}`]);
                this.router.navigate([`productListing/category/${this.searchResult}/outletId/${this.searchResult['id']}`]);

              }
              else if (data.general == "Brand") {
                console.log("333")
                // this.router.navigate([`productListing/category/${this.searchResult['category']}/outletId/${this.searchResult['id']}`]);
                this.router.navigate([`productListing/brand/${this.searchResult}/outletId/${this.searchResult['id']}`]);

              }
              else if (data.general == "Outlet") {
                console.log("123")
                this.router.navigate([`/productListing/outletId/${this.searchResult['id']}`]);
              }  
            }
            else {
              // this.preList = [];
              // this.preList.push({ "name": resp.message })
              console.log("444")
            }
          }
          if (resp.success == 0) {
  
          }
  
        },
  
        err => {
          if (err.error.error.message) {
            console.log(err.error.error.message)
          }
          else {
            console.log('Something bad happened; Please try again!')
          }
        })
  
      this.preList = [];
  

    }
else{
  this.router.navigate([`/login`]);
}
 
  }
  removeItem(index) {
    console.log(index, "index", this.cartProducts[0].products[index]);
    this.cartProducts[0].products.splice(index, 1);
    var totalItems = 0;
    var totalquantity = 0;
    delete this.cartProducts[0]._id;
    for (let k = 0; k < this.cartProducts[0].products.length; k++) {
      totalquantity = totalquantity + this.cartProducts[0].products[k].quantity;
      totalItems = k + 1;


    }
    this.cartProducts[0].total_items = totalItems;
    this.cartProducts[0].total_quantity = totalquantity;

    this.cartService.updateCartProducts(this.cartProducts);
    let cartCreateRequestBody = {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": Number(this.storedValue.userId),

      "payload": {
        "cart_creation":

          this.cartProducts[0]

      }
    }
    try {
      this.appService
        .postApiCall(cartCreateRequestBody, ENDPOINTS.UPDATE_CART)
        .subscribe(
          (resp) => {
            if (resp) {
              if (resp.success === 1 && resp.status_code === 200) {

                this.cartGetAll();






              } else if (resp.success === 0) {
                if (resp.message) {
                  //this.alertService.error(resp.message, this.options);
                }
              } else if (resp.message && resp.status_code !== 200) {
                //this.alertService.error(resp.message, this.options);
              } else {
                //this.alertService.error('Something bad happened. Please try again!', this.options);
              }
            }
          },
          (err) => {
            if (err.error.statusCode === 403) {
              //this.alertService.error('Session Time Out! Please login Again', this.options)
            } else if (err.error.error.message) {
              //this.alertService.error(err.error.error.message, this.options)
            } else {
              //this.alertService.error('Something bad happened. Please try again!', this.options);
            }
          }
        );
    } catch (err) {
      console.log("ERROR IN ADDING ITEM: ", err);
    }
  }
  cartGetAll() {
    this.cartProducts = [];

    let cart_requestbody = {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": Number(this.storedValue.userId),
      "extras":
      {
        "find":
          { "user_id": Number(this.storedValue.userId) }
      }
    }


    try {
      this.appService
        .postApiCall(cart_requestbody, ENDPOINTS.GET_CART)
        .subscribe(
          (resp) => {
            if (resp) {
              if (resp.success === 1 && resp.status_code === 200) {
                console.log("resp.result.data", resp.result.data)
                var tempArray = resp.result.data;
                var length = resp.result.data.length;
                console.log(tempArray, "tempArray")
                if (resp.result.data.length != 0) {
                  this.cartProducts.push(tempArray[length - 1]);
                  this.cartService.updateCartProducts(this.cartProducts);
                  console.log(this.cartProducts, "  this.cartProducts", this.cartProducts.length)







                }
                else {
                  this.cartProducts = [];

                }









              } else if (resp.success === 0) {
                if (resp.message) {
                  //this.alertService.error(resp.message, this.options);
                }
              } else if (resp.message && resp.status_code !== 200) {
                //this.alertService.error(resp.message, this.options);
              } else {
                //this.alertService.error('Something bad happened. Please try again!', this.options);
              }
            }
          },
          (err) => {
            if (err.error.statusCode === 403) {
              //this.alertService.error('Session Time Out! Please login Again', this.options)
            } else if (err.error.error.message) {
              //this.alertService.error(err.error.error.message, this.options)
            } else {
              //this.alertService.error('Something bad happened. Please try again!', this.options);
            }
          }
        );
    } catch (err) {
      console.log("ERROR IN ADDING ITEM: ", err);
    }

  }
  navigateToShop(){
   if( this.userLoggedIn==true){
    this.router.navigate([`/Shops`]);

   }
   else{
    this.router.navigate([`/login`]);
    
   }
    

  }
  viewCart(){
    this.router.navigate([`/cart`]);

  }
  redirectToHome() {
    this.router.navigate(['/']); // Navigate to the home route
  }
  navigateBasedOnCategory(category){
     if( this.userLoggedIn==true){
      this.router.navigateByUrl(`/Shops/${category}`)


     }
     else{
      this.router.navigate([`/login`]);

     }
  
    }


  }



